import React, { useState, useEffect, useRef } from 'react';
import './TauriUserView.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import TauriAboutUs from '../TauriAboutUs/TauriAboutUs';
import { Modal, Button } from 'react-bootstrap';
import config from '../../appURL.json';
import OpalAlertModal from '../OpalAlertModal/OpalAlertModal';
import { SessionTag, statusMapping, SyncStatusMap } from '../../visualizations/visualizations';
import { getAll } from '../../localDB';

const TauriUserView = ({ fullname, title }) => {
    const [dropdownVisible, setDropdownVisible] = useState(false);
    const [showAboutUs, setShowAboutUs] = useState(false);
    const [showLogoutModal, setShowLogoutModal] = useState(false);
    const [logoutModalProps, setLogoutModalProps] = useState({
        title: "",
        bodyText: "",
        confirmButtonText: "",
        cancelButtonText: "",
        Icon: "",
        modalType: ""
    });
    const dropdownRef = useRef(null);

    const toggleDropdown = () => {
        setDropdownVisible(!dropdownVisible);
    };

    const handleClickOutside = (event) => {
        if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
            setDropdownVisible(false);
        }
    };

    const handleShowAboutUs = () => setShowAboutUs(true);
    const handleCloseAboutUs = () => setShowAboutUs(false);

    useEffect(() => {
        document.addEventListener('click', handleClickOutside);

        return () => {
            document.removeEventListener('click', handleClickOutside);
        };
    }, []);

    const handleConfirmation = async () => {
        const allSessions = await getAll("session");
        const allAttendance = await getAll("Attendance");
        const sessionChanges = allSessions.filter(
            (a) =>
                a.Tag == null &&
                (a.SyncStatus === SyncStatusMap.create || a.SyncStatus === SyncStatusMap.update) &&
                a.Status !== statusMapping.inprogress
        );

        const attendanceChanges = allAttendance
            .filter(a => a.SyncStatus === SyncStatusMap.create || a.SyncStatus === SyncStatusMap.update);

        if (sessionChanges.length > 0 || attendanceChanges.length > 0) {
            setLogoutModalProps({
                title: "Warning",
                bodyText: "There are unsynced changes. Please sync your data before logging out to avoid losing them.",
                confirmButtonText: "",
                cancelButtonText: "Ok",
                Icon: "/Images/material-symbols--warning.svg",
                modalType: "message"
            });
        } else {
            setLogoutModalProps({
                title: "Confirm Logout",
                bodyText: "Do you really want to logout?",
                confirmButtonText: "Logout",
                cancelButtonText: "Cancel",
                Icon: "",
                modalType: "question"
            });
        }

        setShowLogoutModal(true);

    }

    const handleLogout = async (event) => {
        const lid = localStorage.getItem('lid');
        const appVersion = localStorage.getItem('app_version');

        window.localStorage.clear();

        if (lid) localStorage.setItem('lid', lid);
        if (appVersion) localStorage.setItem('app_version', appVersion);
        const currentPath = config.APP_BaseURL;
        localStorage.setItem('returnUrl', '/');
        window.location.href = `${config.API_IDENTITY_Authorize}/Identity/Account/Login?returnUrl=${encodeURIComponent(currentPath)}`;
    };

    const handleClickFAQ = () => {
        window.open(`${config.APP_BaseURL}/FAQ.html`, "_blank", "noopener,noreferrer");
    }

    const getInitials = (firstName, lastName) => {
        let firstInitial = '';
        let lastInitial = '';

        if (firstName) {
            const firstNameWords = firstName.split(' ');
            firstInitial = firstNameWords.length > 1 ? firstNameWords[0].charAt(0) : firstName.charAt(0);
        }

        if (lastName) {
            const lastNameWords = lastName.split(' ');
            lastInitial = lastNameWords.length > 1 ? lastNameWords[0].charAt(0) : lastName.charAt(0);
        }

        return `${firstInitial}${lastInitial}`.toUpperCase();
    };

    return (
        <div className="user-view" onClick={toggleDropdown} ref={dropdownRef}>
            <div className='user-view-details me-2'>
                <div className='circle-container'>
                    <div className="circle align-items-center">
                        <span>{getInitials(fullname || '')}</span>
                    </div>
                </div>
                <div className="userInfo d-none d-lg-block d-lg-flex flex-column align-items-end justify-content-center">
                    <div className="d-flex text-white">
                        <span className="userName">{fullname}</span>
                    </div>
                    <hr className="horizontalLine" />
                    <div className="d-flex text-white">
                        <span className="userPosition">{title}</span>
                    </div>
                </div>
                <div className="dropdown p-0">
                    <button className="btn dropdown-toggle" type="button" id="dropdownMenuButton" data-bs-toggle="dropdown" aria-expanded={dropdownVisible}></button>
                    <ul className={`dropdown-menu dropdown-menu-end p-0 ${dropdownVisible ? 'show' : ''}`} aria-labelledby="dropdownMenuButton">
                        <li className="mt-2">
                            <a className="dropdown-item d-flex align-items-center justify-content-start" onClick={handleClickFAQ}>
                                <img src={process.env.PUBLIC_URL + "/Images/carbon--settings.svg"} alt="Icon" />
                                FAQ
                            </a>
                        </li>

                        <li className="d-flex align-items-center justify-content-center">
                            <hr className="m-0 my-0 " />
                        </li>

                        <li>
                            <a className="dropdown-item d-flex align-items-center justify-content-start" onClick={handleShowAboutUs}>
                                <img src={process.env.PUBLIC_URL + "/Images/mdi--about-circle.svg"} alt="Icon" />
                                About Us
                            </a>
                        </li>

                        <li>
                            <a className="dropdown-item d-flex align-items-center justify-content-start" onClick={handleConfirmation}>
                                <img src={process.env.PUBLIC_URL + "/Images/mdi--sign-out.svg"} alt="Icon" />
                                Sign-Out
                            </a>
                        </li>
                    </ul>
                </div>
            </div>
            <TauriAboutUs
                show={showAboutUs}
                onHide={handleCloseAboutUs}
            />
            <OpalAlertModal
                show={showLogoutModal}
                onHide={() => setShowLogoutModal(false)}
                title={logoutModalProps.title}
                bodyText={logoutModalProps.bodyText}
                onConfirm={handleLogout}
                confirmButtonText={logoutModalProps.confirmButtonText}
                cancelButtonText={logoutModalProps.cancelButtonText}
                modalType={logoutModalProps.modalType}
                Icon={logoutModalProps.Icon}
            />
        </div >
    );
};

export default TauriUserView;
